// extracted by mini-css-extract-plugin
module.exports = {"skeleton-box":"Loading_skeleton-box__C6hLd","shimmer":"Loading_shimmer__auZAs"};